import _ from 'lodash'
import { baseApiService } from './base'

const BASE_URL = '/api/v1/etmf/fileplan'

export async function get(filePlanId: number | string) {
  return baseApiService.fetch(`${BASE_URL}/${filePlanId}`)
}
// TypeScript migration of legacy getEntries
export async function getEntries(filePlanId: string, level: string): Promise<any> {
  return baseApiService.fetch(`${BASE_URL}/${filePlanId}/entries/${level}`)
}

// TypeScript migration of legacy getEntriesForSelector
export async function getEntriesForSelector(
  filePlanId: string,
  level: string,
  selectedIds?: string[],
  isClone?: boolean,
  isFilePlanChanged?: boolean,
  entryNames?: string[]
): Promise<any[]> {
  const selectedMap = (selectedIds ?? []).reduce(
    (mem, id) => {
      mem[id] = id
      return mem
    },
    {} as Record<string, string>
  )

  const selectedNameMap =
    isClone && isFilePlanChanged && Array.isArray(entryNames) && entryNames.length
      ? (entryNames ?? []).reduce(
          (mem, name) => {
            mem[name] = name
            return mem
          },
          {} as Record<string, string>
        )
      : {}

  const resp = await getEntries(filePlanId, level)
  const entriesL_1 = resp.plain ? resp.plain() : resp
  return _.map(entriesL_1, (entriesL_2, nameL1) => {
    const entityL1: any = { level: 1, containsContaining: 0 }
    entriesL_2 = _.map(entriesL_2, (entriesL_3, nameL2) => {
      const entityL2: any = { level: 2, containsContaining: 0 }
      entriesL_3 = _.map(entriesL_3, (entryL_3: any) => {
        const isSelected = !!(isClone && isFilePlanChanged ? selectedNameMap[entryL_3.name] : selectedMap[entryL_3.id])
        return {
          ...entryL_3,
          level: 3,
          selected: isSelected,
          hasChildren: false,
          parent: entityL2,
          isArtifact: true,
          identifier: entryL_3.id
        }
      })
      if (entityL2.containsContaining > 0) {
        entityL1.containsContaining++
      }
      const selectedLev3 = _.filter(entriesL_3, { selected: true })
      const expandedL2 = selectedLev3.length > 0
      return {
        ...entityL2,
        expanded: expandedL2,
        wasExpanded: expandedL2,
        selected: entriesL_3 && entriesL_3.length > 0 && selectedLev3?.length === entriesL_3.length,
        containsSelected: selectedLev3.length,
        containsContaining: selectedLev3.length,
        hasChildren: entriesL_3.length > 0,
        parent: entityL1,
        name: nameL2,
        identifier: nameL1 + '_' + nameL2,
        children: entriesL_3
      }
    })
    const selectedLev2 = _.filter(entriesL_2, { selected: true })
    const expandedLev2 = _.filter(entriesL_2, { expanded: true })
    const containingLev2 = _.filter(entriesL_2, (entry: any) => entry.containsContaining > 0)
    const expandedL1 = selectedLev2.length > 0 || expandedLev2.length > 0
    return {
      ...entityL1,
      expanded: expandedL1,
      wasExpanded: expandedL1,
      selected: entriesL_2 && entriesL_2.length > 0 && selectedLev2?.length === entriesL_2.length,
      containsSelected: selectedLev2.length,
      containsContaining: containingLev2.length,
      hasChildren: entriesL_2.length > 0,
      name: nameL1,
      identifier: nameL1,
      children: entriesL_2
    }
  })
}

// TypeScript migration of legacy getLevel3Entries
export function getLevel3Entries(entriesL1: any[], predicate?: (entry: any) => boolean): any[] {
  const entries: any[] = []
  entriesL1.forEach((entryL1) => {
    entryL1.children?.forEach((entryL2: any) => {
      entryL2.children?.forEach((entryL3: any) => {
        if (typeof predicate === 'function') {
          if (predicate(entryL3)) {
            entries.push(entryL3)
          }
        } else {
          entries.push(entryL3)
        }
      })
    })
  })
  return entries
}
